<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-building page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2 disabled"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4" style="width:300px; max-width:50vw;">
							<div class="input-group">
								<input type="text" class="form-control" id="status-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch($(this).val())" />
								<span class="input-group-text"><i class="fa fa-search"></i></span>
							</div>
						</div>

						<h2>Adatbázisok</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Adatbázisok</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'company_db',
						params: {
							row_height: 48,
							row_class: (row) => {
								if (row.sandbox) return 'bg-body-secondary text-dim'
								return ''
							},
							columns: [
								/*
								{
									title: 'ID',
									field: 'id',
									type: 'number',
									width: 60
								},
								*/
								{
									title: 'Adatbázis',
									field: 'db_name',
									type: 'string',
									type: {
										render (value, row, options) {
											if (value !== null) {
												return `<a href="https://dbserver01.webdisk.hu:8010/phpmyadmin/index.php?route=/database/structure&db=c1_cstore_${value}" target="_blank" class="btn btn-dark text-light p-2 float-start me-2"><i class="fa fa-fw fa-server"></i></a> <strong>${value}</strong><br /><small class="text-dim">${row.server}</small>`
											} else {
												return ''
											}
										}
									},
									options: {
										cutoff: 60
									},
									width: 220
								},
								{
									title: 'API kulcs',
									field: 'webapi_authcode',
									type: 'string',
									options: {
										cutoff: 40
									},
									width: 160
								},
								{
									title: 'Cég',
									field: 'company_id',
									value: (v) => {
										const company = Anvil.page.companies.getById(v)
										return company ? `${company.name} ${company.tax_number}` : ''
									},
									type: {
										render (value, row, options) {
											const company = Anvil.page.companies.getById(row.company_id)
											if (company === undefined) return '&nbsp;<br /><small>&nbsp;</small>'
											return `<div class="list-db-id">${company.id}</div> ${company.name}<br /><small class="text-dim">${company.tax_number}</small>`
										}
									},
									options: {
										cutoff: 60
									},
									width: 240
								},
								{
									title: 'Szerviz partner',
									field: 'service_partner_id',
									value: (v) => {
										const company = Anvil.page.companies.getById(v)
										return company ? company.name : ''
									},
									type: 'string',
									options: {
										cutoff: 40
									},
									width: 300
								},
								{
									title: 'Műveletek',
									field: 'id',
									value: (v, row) => {
										if (row.company_group_name !== null) {
											return row.company_group_name
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											const cloud_btn = (row.db_name !== null)
												? `<button class="btn btn-dark text-warning p-2" onclick="Anvil.page.sign_in_to_cloud('${row.db_name}')"><i class="fa fa-fw fa-sign-in-alt text-info"></i></button>`
												: `<button class="btn btn-dark text-dim disabled p-2"><i class="fa fa-fw fa-sign-in-alt"></i></button>`

											return `<div class="btn-group">${cloud_btn}</div>`
										}
									},
									options: {
										class: 'text-center pb-0 overflow-visible'
									},
									width: 120
								},
							]
						},
						list: company_dbs
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<div class="btn-group">
						<button class="btn btn-success" onclick="Anvil.page.new()"><i class="fa fa-fw fa-plus"></i><span class="d-none d-md-inline ms-2">Új adatbázis</span></button>
						<button class="btn btn-success" onclick="Anvil.page.copy()"><i class="fa fa-fw fa-copy"></i><span class="d-none d-md-inline ms-2">Adatbázis másolása</span></button>
					</div>
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
					<button class="btn btn-danger ml-2" onclick="Anvil.page.delete()"><i class="fa fa-fw fa-trash"></i><span class="d-none d-md-inline ms-2">Törlés</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	quickSearch (expression) {
		Anvil.models.components.Grid.find('#company_db_grid').filter(expression)
	},

	refresh () {
		Anvil.exec('c_order/company_db/action_refresh')
	},

	new () {
		Anvil.exec('c_order/company_db/modal_edit')
	},

	async sign_in_to_cloud (db_name) {
		const token = await Anvil.exec('c_order/company_db/action_get_sign_in_token', db_name)
		if (token) {
			window.open(`https://ugyfel.c-store.eu/sys_login_1.html?CEGID=${db_name}&logintoken=${token}`, '_blank')
		}
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#company_db_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/company_db/modal_edit', sel[0].id)
		}
	},

	delete () {
		let sel = Anvil.models.components.Grid.find('#company_db_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/company_db/action_delete', sel[0].id)
		}
	}
})

$('#company_db_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
